module.exports = __webpack_public_path__ + "img/participants.499f308e.svg";